export default __webpack_public_path__ + "static/O0035-6419286519c12a1e1d7d705e39564e49.png";